import React, { useEffect } from 'react';
import { Box } from '@mui/material';

const GoogleReviewsWidget = () => {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.src = 'https://featurable.com/assets/bundle.js';
    script.defer = true;
    script.charset = 'UTF-8';
    
    // Append script to document body
    document.body.appendChild(script);
    
    // Clean up function to remove script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty array ensures this runs only once on component mount

  return (
    <Box sx={{ width: '100%', my: 4 }}>
      <div 
        id="featurable-1d25f4d0-615a-4c32-9244-c08523566700" 
        data-featurable-async 
        data-location-code="es"
      />
    </Box>
  );
};

export default GoogleReviewsWidget;

